document.querySelectorAll('.rp-timeline__splide').forEach(function (splideEl) {
  var root = splideEl.closest('.rp-timeline');
  if (!root || typeof Splide === 'undefined') return;

  var splide = new Splide(splideEl, {
    type      : 'loop',
    perPage   : 1,
    arrows    : false,
    pagination: false,
    /* Chaque étape peut avoir un texte de longueur très différente : sans
       autoHeight, Splide (comme l'ancien empilement CSS) donnerait à toutes
       les slides la hauteur de la plus haute, laissant un vide avant la
       navigation sur les étapes plus courtes. */
    autoHeight: false,
    gap       : 0,
    speed     : 500,
  });

  function setActive(i) {
    root.querySelectorAll('[data-tl-step]').forEach(function (el) {
      var active = parseInt(el.getAttribute('data-tl-step'), 10) === i;
      el.classList.toggle('is-active', active);
      var tab = el.querySelector('[role="tab"]');
      if (tab) tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  splide.on('mounted', function () {
    setActive(splide.index);
  });
  /* 'move' (pas 'moved') : se déclenche au DÉBUT de la transition Splide, pas
     à la fin. Avec 'moved', le rail et l'image n'étaient mis à jour qu'une
     fois le texte déjà arrivé (donc visiblement en retard). 'move' fournit
     le nouvel index tout de suite, donc rail/image démarrent leur propre
     transition en même temps que le texte. */
  splide.on('move', function (newIndex) {
    setActive(newIndex);
  });

  splide.mount();

  /* Rail (dates cliquables) et flèches partagées pilotent Splide, qui reste
     la seule source de vérité pour l'étape courante. */
  root.querySelectorAll('[data-tl-go]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      splide.go(parseInt(btn.getAttribute('data-tl-go'), 10));
    });
  });

  var prev = root.querySelector('[data-tl-prev]');
  var next = root.querySelector('[data-tl-next]');
  if (prev) prev.addEventListener('click', function () { splide.go('<'); });
  if (next) next.addEventListener('click', function () { splide.go('>'); });
});
